import {
  DocumentServicesObject,
  EditorClientSpecMapEntry,
} from '@wix/document-services-types';
import {
  Group,
  AppGroup,
  AppExposure,
} from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../../../types/platformApi';
import { EditorClientSpecMapEntryWithSections } from './types';
import { getSections, getSubGroups } from './utils';
import { mapDefinitionToGroup, mapDefinitionAppGroup } from './mappers';
import { ExposureService } from '../exposureService/exposureService';

export const getGroups = (
  documentServices: DocumentServicesObject,
  context: PlatformContext,
): Group[] => {
  const installedApps: EditorClientSpecMapEntry[] =
    documentServices.platform.getInstalledEditorApps();
  return installedApps
    .map((installedApp: EditorClientSpecMapEntry) => ({
      app: installedApp,
      sections: getSections(documentServices, context, installedApp),
    }))
    .filter(
      (installedAppWithSections: EditorClientSpecMapEntryWithSections) =>
        installedAppWithSections.sections.length,
    )
    .map(mapDefinitionToGroup);
};

export const getAppsComponents = (
  documentServices: DocumentServicesObject,
  context: PlatformContext,
): AppGroup[] => {
  const installedApps: EditorClientSpecMapEntry[] =
    documentServices.platform.getInstalledEditorApps();

  return installedApps
    .filter((app) => !app.isWixTPA)
    .map((installedApp: EditorClientSpecMapEntry) => ({
      app: installedApp,
      subGroups: getSubGroups(
        documentServices,
        context,
        installedApp.appDefinitionId,
      ),
    }))
    .filter(
      (installedAppWithSubGroups) => installedAppWithSubGroups.subGroups.length,
    )
    .map(mapDefinitionAppGroup);
};

// Returns each installed app's EditorExposure COMPONENTS groups as AppExposure[].
export const getEditorExposureAppComponents = (
  documentServices: DocumentServicesObject,
  context: PlatformContext,
): Promise<AppExposure[]> =>
  ExposureService.getComponentGroups(documentServices, context);
